export enum PermitStep {
    preparationRoleSelection = 110,
    preparationFixedQuestions = 115,
    preparationCustomerCheckpoints = 120,
    preparationPhoto = 125,
    preparationComplete = 130,
    isFlammableHotWork = 200,
    isWorkplaceTemporary = 205,
    workplace = 210,
    emergencyLocation = 215,
    flammableAtexQuestion = 218,
    workMethod = 220,
    additionalInformation = 222,
    fireAlarm = 223,
    fixedQuestions = 225,
    flammableMaterialsFixedQuestions = 226,
    atexFixedQuestions = 227,
    gasFreeCertificatesFixedQuestions = 228,
    safetyEquipmentFixedQuestions = 229,
    customerCheckpoints = 230,
    flammableMaterialsCustomerCheckpoints = 231,
    atexCustomerCheckpoints = 232,
    photo = 235,
    postWorkMonitoringTime = 245,
    team = 250,
    gasFreeCertification = 251,
    signing = 255,
    duration = 260,
    flammableAtexPermitCreated = 270,
    started = 310,
    expiredNotSigned = 315,
    ended = 410,
    archived = 415,
}
